export default __webpack_public_path__ + "./assets/scooter__9d5884372cb5a20790204dd91b23bff3.png";